<ng-container *ngIf="!(appState.iframeLoginMode.obs$ | async) || (appState.ssoStatus.obs$ | async) === 'success'">
    <app-header *ngIf="showHeader" [isNav]="true" class="no-print"></app-header>
    <div class="content-wrap" [ngClass]="{'login': isLoginPage}">
        <router-outlet></router-outlet>
    </div>
</ng-container>

<div class="sso-overlay" *ngIf="(appState.iframeLoginMode.obs$ | async) && (appState.ssoStatus.obs$ | async) !== 'idle' && (appState.ssoStatus.obs$ | async) !== 'success'">
    <div class="sso-content">
        <div *ngIf="(appState.ssoStatus.obs$ | async) === 'initializing' || (appState.ssoStatus.obs$ | async) === 'validating'" class="sso-loading">
            <mat-spinner diameter="50"></mat-spinner>
            <p>{{ 'SSO.LOADING' | translate }}</p>
        </div>
        <div *ngIf="(appState.ssoStatus.obs$ | async) === 'error'" class="sso-error">
            <mat-icon color="warn">error_outline</mat-icon>
            <h3>{{ 'SSO.ERROR_TITLE' | translate }}</h3>
            <p>{{ appState.ssoError.obs$ | async }}</p>
        </div>
    </div>
</div>

<app-loader></app-loader>

<footer class="no-print">
    <div class="footer-container">
        <div class="footer-panels flex-h">
            <div class="footer-panel flex-fill">
                <span>© {{year}}</span>&nbsp;<a href="https://quantille.hu" _target="_blank">Quantille</a> <span class="inline">&nbsp;•&nbsp;</span><span>{{ 'FOOTER.ALL_RIGHTS_RESERVED' | translate }}</span>
            </div>
            <div class="footer-panel flex-fill flex-h flex-end">
                <div class="footer-menu">
                    <ul class="flex-h gap-10">
                        <li><a href="https://quantille.hu/impresszum/" _target="_blank">{{ 'FOOTER.IMPRESSUM' | translate }}</a></li>
                        <li><a rel="privacy-policy" href="{{ 'FOOTER.PRIVACY_POLICY_LINK' | translate }}" target="_blank">{{ 'FOOTER.PRIVACY_POLICY' | translate }}</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>  
</footer>
